export enum PackageType {
    LIGHT = 'light',
    STANDARD = 'standard',
    PRO = 'pro',
}
